export default __webpack_public_path__ + "static/media/selectcuts.01a53469.jpg";